// extracted by mini-css-extract-plugin
export default {"cls1":"RecommendedPodcastBadge-cls1___83f29eea4289cd1c4e0","cls2":"RecommendedPodcastBadge-cls2__d6049516b0e98ad92584 RecommendedPodcastBadge-cls1___83f29eea4289cd1c4e0"};